// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { MovementType } from '@/items/api/get-item-movement-history';

/**
 * Labels for movement types.
 */
const movementTypeLabels: Record<MovementType, string> = {
  RECEIVE: 'Receive',
  CONSUME: 'Consume',
  TRANSFER: 'Transfer',
  ADJUST: 'Adjust',
  RETURN: 'Return',
  SHIP: 'Ship',
  DELIVER: 'Deliver',
};

/**
 * Formats a movement type for display.
 */
export function formatMovementType(movementType: MovementType): string {
  return movementTypeLabels[movementType];
}
